import CSS from "./static/css/ContractDate.module.css";
import { ReactNode, useMemo } from "react";
import Text from "../../../../../Component/Elements/Text/Text";
import useIsMobile from "../../../../../Common/hooks/useIsMobile";

const PayDate = (
    {
        children,
        className,
        is_header,
    }:{
        children?: ReactNode,
        className?: string;
        is_header?: boolean;
    }
) => {
    const isMobile = useIsMobile();

    const mainClassName = useMemo(() => {
        const RTN: string[] = [];

        if(className){
            RTN.push(className);
        }

        RTN.push(CSS.l_ContractDate_main);

        return RTN.join(" ");
    }, [className])

    return(
        <div className={mainClassName}>
            <Text 
                size={isMobile ? "size1" : "size2"}
                color={is_header ? "gray2" : undefined}
            >
                {children}
            </Text>
        </div>
    )
}

export default PayDate;